module.exports = "/images/vendor/flag-icon-css/flags/1x1/in.svg?209ae8e9585774eb4fe32c001f7c63cc";